import { useNavigate, useOutletContext, useSearchParams } from 'react-router-dom'

import { GoogleMapsProvider } from 'modules/core/components/GoogleMaps/GoogleMapsProvider'
import Loading from 'modules/core/components/Loading'

import CreatePerDiemForm from 'modules/expenses/components/expenses/Detail/_newForm/CreatePerDiemForm'
import { fieldEnabled } from 'modules/expenses/hooks/useExpensesCustomization'
import { useExpensesNavigation } from 'modules/expenses/hooks/useExpensesNavigation'
import useNewExpensesPage from 'modules/expenses/hooks/useNewExpensesPage'
import type { RouteContextParams } from 'modules/expenses/lib/my_expenses/RouteContextParams'

const NewPerDiemPage = () => {
  const { group } = useOutletContext<RouteContextParams>()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { navigation } = useExpensesNavigation()

  const {
    customizationFields,
    hasProjectsFeature,
    hasReportOnBehalfFeature,
    loading,
    canCreateExpensesForOthers,
    canCustomizeSettings,
    canSeeEmployeeLegalEntity,
  } = useNewExpensesPage()

  if (loading) return <Loading inline />

  return (
    <GoogleMapsProvider
      mapsEnabled={
        fieldEnabled(customizationFields, 'perdiem', 'from') ||
        fieldEnabled(customizationFields, 'perdiem', 'to')
      }
    >
      <CreatePerDiemForm
        canCustomizeSettings={canCustomizeSettings}
        customizationFields={customizationFields}
        hasProjectsFeature={hasProjectsFeature}
        canSeeEmployeeLegalEntity={canSeeEmployeeLegalEntity}
        hasReportOnBehalfFeature={hasReportOnBehalfFeature}
        canCreateExpensesForOthers={canCreateExpensesForOthers}
        groupCurrency={group?.currency}
        onClose={() =>
          navigate({
            pathname: navigation.helpers.getExpensesFormBackPath(),
            search: searchParams.toString(),
          })
        }
      />
    </GoogleMapsProvider>
  )
}

export default NewPerDiemPage
